import { MutableRefObject, useRef } from "react";

export const useDefaultRef = <TRef>(ref?: MutableRefObject<TRef>) => {
  const ownRef = useRef<TRef>();

  return (ref || ownRef) as MutableRefObject<TRef>;
};
